/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../appointments/api/public';
import '../connect/v2/resources/error';
import '../client/rolodex/data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "customerFieldDefinitionSetting": {
        "nested": {
          "CustomerFieldDefinitionSetting": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "customerFieldDefinitionKey": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "bookingType": {
                "type": ".squareup.connect.v2.bookings.service.BookingType",
                "id": 3,
                "rule": "optional"
              },
              "settingId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "CustomerFieldDefinitionSettingsByBookingType": {
            "fields": {
              "bookingType": {
                "type": ".squareup.connect.v2.bookings.service.BookingType",
                "id": 1,
                "rule": "optional"
              },
              "settings": {
                "type": ".squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSetting",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ListCustomerFieldDefinitionsRequest": {
            "fields": {}
          },
          "ListCustomerFieldDefinitionsResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              },
              "attributeDefinitions": {
                "type": ".squareup.client.rolodex.AttributeSchema.AttributeDefinition",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "ListCustomerFieldDefinitionSettingsRequest": {
            "fields": {
              "bookingType": {
                "type": ".squareup.connect.v2.bookings.service.BookingType",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ListCustomerFieldDefinitionSettingsResponse": {
            "fields": {
              "settingsByBookingType": {
                "type": ".squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSettingsByBookingType",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              },
              "attributeDefinitionsMap": {
                "type": ".squareup.client.rolodex.AttributeSchema.AttributeDefinition",
                "id": 4,
                "keyType": "string"
              }
            }
          },
          "CreateCustomerFieldDefinitionSettingRequest": {
            "fields": {
              "setting": {
                "type": ".squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSetting",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CreateCustomerFieldDefinitionSettingResponse": {
            "fields": {
              "setting": {
                "type": ".squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSetting",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "DeleteCustomerFieldDefinitionSettingRequest": {
            "fields": {
              "settingId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "DeleteCustomerFieldDefinitionSettingResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "CustomerFieldDefinitionSettingService": {
            "methods": {
              "ListCustomerFieldDefinitions": {
                "requestType": ".squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionsRequest",
                "responseType": ".squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionsResponse"
              },
              "ListCustomerFieldDefinitionSettings": {
                "requestType": ".squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionSettingsRequest",
                "responseType": ".squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionSettingsResponse"
              },
              "CreateCustomerFieldDefinitionSetting": {
                "requestType": ".squareup.customerFieldDefinitionSetting.CreateCustomerFieldDefinitionSettingRequest",
                "responseType": ".squareup.customerFieldDefinitionSetting.CreateCustomerFieldDefinitionSettingResponse"
              },
              "DeleteCustomerFieldDefinitionSetting": {
                "requestType": ".squareup.customerFieldDefinitionSetting.DeleteCustomerFieldDefinitionSettingRequest",
                "responseType": ".squareup.customerFieldDefinitionSetting.DeleteCustomerFieldDefinitionSettingResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.CustomerFieldDefinitionSetting && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.CustomerFieldDefinitionSettingsByBookingType && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.ListCustomerFieldDefinitionsRequest && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.ListCustomerFieldDefinitionsResponse && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.ListCustomerFieldDefinitionSettingsRequest && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.ListCustomerFieldDefinitionSettingsResponse && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.CreateCustomerFieldDefinitionSettingRequest && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.CreateCustomerFieldDefinitionSettingResponse && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.DeleteCustomerFieldDefinitionSettingRequest && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.DeleteCustomerFieldDefinitionSettingResponse && !$root.nested?.squareup?.nested?.customerFieldDefinitionSetting?.nested?.CustomerFieldDefinitionSettingService) {
  $root.addJSON(jsonData);
}

/**
 * To generate protos after editing:
 * $ bundle exec rake sq:protos:compile
 * Represents a customer field that should be displayed in specific settings (e.g. OBS)
 *
 * SOURCE CustomerFieldDefinitionSetting @ squareup/customer_field_definition_setting/service.proto at 19:1
 */
export const CustomerFieldDefinitionSetting = $root.lookupType('squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSetting');
fixType(CustomerFieldDefinitionSetting, {
  customerFieldDefinitionKey: {
    required: true
  },
  bookingType: {
    required: true
  }
});
Builder.createAndAttachToType(CustomerFieldDefinitionSetting);
/**
 * A grouping of booking type to settings for that booking type
 *
 * SOURCE CustomerFieldDefinitionSettingsByBookingType @ squareup/customer_field_definition_setting/service.proto at 34:1
 */
export const CustomerFieldDefinitionSettingsByBookingType = $root.lookupType('squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSettingsByBookingType');
fixType(CustomerFieldDefinitionSettingsByBookingType, {
  bookingType: {
    required: true
  }
});
Builder.createAndAttachToType(CustomerFieldDefinitionSettingsByBookingType);
/**
 * Retrieves a filtered list of customer field definitions from Rolodex
 *
 * SOURCE ListCustomerFieldDefinitionsRequest @ squareup/customer_field_definition_setting/service.proto at 41:1
 */
export const ListCustomerFieldDefinitionsRequest = $root.lookupType('squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionsRequest');
fixType(ListCustomerFieldDefinitionsRequest);
Builder.createAndAttachToType(ListCustomerFieldDefinitionsRequest);
/**
 * SOURCE ListCustomerFieldDefinitionsResponse @ squareup/customer_field_definition_setting/service.proto at 45:1
 */
export const ListCustomerFieldDefinitionsResponse = $root.lookupType('squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionsResponse');
fixType(ListCustomerFieldDefinitionsResponse);
Builder.createAndAttachToType(ListCustomerFieldDefinitionsResponse);
/**
 * Retrieves Appointments stored settings of customer field definitions
 *
 * SOURCE ListCustomerFieldDefinitionSettingsRequest @ squareup/customer_field_definition_setting/service.proto at 56:1
 */
export const ListCustomerFieldDefinitionSettingsRequest = $root.lookupType('squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionSettingsRequest');
fixType(ListCustomerFieldDefinitionSettingsRequest);
Builder.createAndAttachToType(ListCustomerFieldDefinitionSettingsRequest);
/**
 * SOURCE ListCustomerFieldDefinitionSettingsResponse @ squareup/customer_field_definition_setting/service.proto at 62:1
 */
export const ListCustomerFieldDefinitionSettingsResponse = $root.lookupType('squareup.customerFieldDefinitionSetting.ListCustomerFieldDefinitionSettingsResponse');
fixType(ListCustomerFieldDefinitionSettingsResponse);
Builder.createAndAttachToType(ListCustomerFieldDefinitionSettingsResponse);
/**
 * Creates a single customer field definition setting for a merchant
 *
 * SOURCE CreateCustomerFieldDefinitionSettingRequest @ squareup/customer_field_definition_setting/service.proto at 76:1
 */
export const CreateCustomerFieldDefinitionSettingRequest = $root.lookupType('squareup.customerFieldDefinitionSetting.CreateCustomerFieldDefinitionSettingRequest');
fixType(CreateCustomerFieldDefinitionSettingRequest, {
  setting: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCustomerFieldDefinitionSettingRequest);
/**
 * SOURCE CreateCustomerFieldDefinitionSettingResponse @ squareup/customer_field_definition_setting/service.proto at 82:1
 */
export const CreateCustomerFieldDefinitionSettingResponse = $root.lookupType('squareup.customerFieldDefinitionSetting.CreateCustomerFieldDefinitionSettingResponse');
fixType(CreateCustomerFieldDefinitionSettingResponse);
Builder.createAndAttachToType(CreateCustomerFieldDefinitionSettingResponse);
/**
 * SOURCE DeleteCustomerFieldDefinitionSettingRequest @ squareup/customer_field_definition_setting/service.proto at 89:1
 */
export const DeleteCustomerFieldDefinitionSettingRequest = $root.lookupType('squareup.customerFieldDefinitionSetting.DeleteCustomerFieldDefinitionSettingRequest');
fixType(DeleteCustomerFieldDefinitionSettingRequest, {
  settingId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeleteCustomerFieldDefinitionSettingRequest);
/**
 * SOURCE DeleteCustomerFieldDefinitionSettingResponse @ squareup/customer_field_definition_setting/service.proto at 94:1
 */
export const DeleteCustomerFieldDefinitionSettingResponse = $root.lookupType('squareup.customerFieldDefinitionSetting.DeleteCustomerFieldDefinitionSettingResponse');
fixType(DeleteCustomerFieldDefinitionSettingResponse);
Builder.createAndAttachToType(DeleteCustomerFieldDefinitionSettingResponse);
/**
 * SOURCE CustomerFieldDefinitionSettingService @ squareup/customer_field_definition_setting/service.proto at 98:1
 */
export const CustomerFieldDefinitionSettingService = $root.lookupService('squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSettingService');